export const PROJECTS_LOADED_EVENT = 'projects-loaded'
